import { createContext, FunctionComponent, ReactElement, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";

import Api from "src/Config";

export const GrowthChartContext = createContext(null);

type Props = {
  children: ReactElement;
};

const GrowthChartProvider: FunctionComponent<Props> = ({ children }) => {
  const { data, isLoading, error, isFetching } = useQuery({
    queryKey: ["growth_chart"],
    staleTime: 30000,
    queryFn: async () => {
      const {
        data: { data },
      } = await Api.get(`tm/overview?checkType=transaction-volume-yearly`);

      return data;
    },
  });

  const contextValue = useMemo(
    () => ({
      isLoading,
      data,
      error,
      isFetching,
    }),
    [isLoading, data, error, isFetching],
  );
  return (
    <GrowthChartContext.Provider value={contextValue}>
      {children}
    </GrowthChartContext.Provider>
  );
};

export default GrowthChartProvider;
